// External Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Popover from 'material-ui/Popover';
import RaisedButton from 'material-ui/RaisedButton';

// Internal Dependencies
import styles from '../styles/Styles';

// Local variables
const propTypes = {
  eventData: PropTypes.object,
};

const anchorOrigin = {
  horizontal: 'left',
  vertical: 'bottom',
};

const targetOrigin = {
  horizontal: 'left',
  vertical: 'top',
};

const MS_IN_MINUTES = 60 * 1000;
const thisStyle = styles.addToCalendar;
const formatTime = date => date.toISOString().replace(/-|:|\.\d+/g, '');

const calendarURLs = {
  google(eventData) {
    const startDatetime = formatTime(
      new Date(`${eventData.month} ${eventData.date}, ${eventData.year} ${eventData.startTime}`));
    const endDatetime = formatTime(
      new Date(`${eventData.month} ${eventData.date}, ${eventData.year} ${eventData.endTime}`));

    return encodeURI(
      `https://www.google.com/calendar/render?action=TEMPLATE&text=${(eventData.title || '')}&dates=${(startDatetime || '')}/${(endDatetime || '')}&details=${(eventData.description || '')}&location=${(eventData.address || '')}&sprop=&sprop=name:`);
  },

  yahoo(eventData) {
    const startDatetime = new Date(
      `${eventData.month} ${eventData.date}, ${eventData.startTime}`);
    const endDatetime = new Date(
      `${eventData.month} ${eventData.date}, ${eventData.endTime}`);

    const eventDuration = endDatetime
      ? ((endDatetime.getTime() - startDatetime.getTime()) / MS_IN_MINUTES)
      : eventData.duration;

    // Yahoo dates are crazy, we need to convert the duration from minutes to hh:mm
    const yahooHourDuration = eventDuration < 600
      ? `0${Math.floor((eventDuration / 60))}`
      : Math.floor(eventDuration / 60);

    const yahooMinuteDuration = eventDuration % 60 < 10
      ? `0${(eventDuration % 60)}`
      : eventDuration % 60;

    const yahooEventDuration = yahooHourDuration + yahooMinuteDuration;

    // Remove timezone from eventData time
    const st = formatTime(
      new Date(startDatetime - (startDatetime.getTimezoneOffset() * MS_IN_MINUTES))) || '';

    return encodeURI(
      `http://calendar.yahoo.com/?v=60&view=d&type=20&title=${(eventData.title || '')}&st=${st}&dur=${(yahooEventDuration || '')}&desc=${(eventData.description || '')}&in_loc=${(eventData.address || '')}`);
  },

  ics(eventData) {
    const startDatetime = formatTime(new Date(
      `${eventData.month} ${eventData.date}, ${eventData.year} ${eventData.startTime}`));
    const endDatetime = formatTime(new Date(
      `${eventData.month} ${eventData.date}, ${eventData.year} ${eventData.endTime}`));

    return encodeURI(`data:text/calendar;charset=utf8,${[
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'BEGIN:VEVENT',
      `URL:${document.URL}`,
      `DTSTART:${(startDatetime || '')}`,
      `DTEND:${(endDatetime || '')}`,
      `SUMMARY:${(eventData.title || '')}`,
      `DESCRIPTION:${(eventData.description || '')}`,
      `LOCATION:${(eventData.address || '')}`,
      'END:VEVENT',
      'END:VCALENDAR',
    ].join('\n')}`);
  },

  ical(eventData) {
    return this.ics(eventData);
  },

  outlook(eventData) {
    return this.ics(eventData, 'icon-ical', 'iCal');
  },
};


// Component Definition
class AddToCalendar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleClickAddToCalendar = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      anchorEl: event.currentTarget,
      open: true,
    });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  render() {
    try {
      const { eventData } = this.props;

      return (
        <div>
          <RaisedButton
            label="Add to calendar"
            onClick={this.handleClickAddToCalendar}
          />
          <Popover
            anchorEl={this.state.anchorEl}
            anchorOrigin={anchorOrigin}
            onRequestClose={this.handleRequestClose}
            open={this.state.open}
            targetOrigin={targetOrigin}
          >
            <Menu>
              <MenuItem>
                <a
                  href={calendarURLs.google(eventData)}
                  style={thisStyle.anchor}
                >
                  Google Calendar
                </a>
              </MenuItem>
              <MenuItem>
                <a
                  href={calendarURLs.yahoo(eventData)}
                  style={thisStyle.anchor}
                >
                  Yahoo Calendar
              </a>
              </MenuItem>
              <MenuItem>
                <a
                  href={calendarURLs.ical(eventData)}
                  style={thisStyle.anchor}
                >
                  iCal
                </a>
              </MenuItem>
            </Menu>
          </Popover>
        </div>
      );
    } catch (e) {
      return null;
    }
  }
}

AddToCalendar.propTypes = propTypes;
export default AddToCalendar;



/** WEBPACK FOOTER **
 ** ./src/home/AddToCalendar.js
 **/